import React from 'react'

function IconWord({ className = '' }) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' width={40} height={40} className={className}>
            <path d='M7 38.75 V1.25 H27 L33 7.25 V38.75 Z' fill='#ffffff' />
            <path d='M7 38.75 V1.25 H27 L33 7.25 V38.75 Z' fill='none' stroke='#0000a0' strokeWidth='2' />
            <path d='M27 1.25 V7.25 H33' fill='none' stroke='#0000a0' strokeWidth='2' />
            <rect x='2.5' y='21.25' width='35' height='12' fill='#0000a0' />
            <text
                x='20'
                y='27.25'
                fill='#ffffff'
                fontFamily='Arial, Helvetica, sans-serif'
                fontWeight='bold'
                fontSize='9.5'
                textAnchor='middle'
                dominantBaseline='central'
            >
                DOC
            </text>
        </svg>
    )
}

export default IconWord
